import { useEffect, useMemo } from 'react';

interface UseRouteLeavingGuardParams {
  formIsSubmitting: boolean;
  formIsDirty: boolean;
}

export const useWindowConfirmUnload = (params: UseRouteLeavingGuardParams) => {
  const { formIsDirty, formIsSubmitting } = params;

  const showPrompt: boolean = useMemo(() => {
    if (formIsSubmitting) {
      return false;
    }
    return formIsDirty && !formIsSubmitting;
  }, [formIsDirty, formIsSubmitting]);

  useEffect(() => {
    const handler = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      //  eslint-disable-next-line no-param-reassign
      event.returnValue = 'Are you sure you want to leave ? Changes you made will not be saved';
    };

    if (showPrompt) {
      window.addEventListener('beforeunload', handler);
      return () => {
        window.removeEventListener('beforeunload', handler);
      };
    }
    return () => {};
  }, [showPrompt]);
};
